import request from '../request'

//pc微信支付
export function pc_create_order(params) {
  return request({ url: '/api/WxPay/pc_create_order',method: 'post',data: params})
}
//轮询查询支付状态
export function lunWxPayorder(params) {
  return request({ url: '/api/WxPay/lunWxPayorder',method: 'post',data: params})
}
//支付宝查询状态
export function aliPay_create_order(params) {
  return request({ url: '/api/Alipay/aliPay_create_order',method: 'post',data: params})
}


// WEBPACK FOOTER //
// ./src/api/gw/pay.js